import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Dialog, Grid, Box } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { useSnackbar } from 'notistack';
import  DatePicker  from 'rsuite/DatePicker';
import 'rsuite/dist/rsuite.css'
import CustomProvider from "rsuite/CustomProvider";
import es_ES from 'rsuite/locales/es_ES';
import en_US from 'rsuite/locales/en_US';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import useCommonApi from '../../api/useCommonApi';
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import { IFechaFestiva } from '../../entities/catalogos/IFechaFestiva';
import { useZonaHoraria } from '../../contextos/zonaHorariaContext';
import dayjs from "dayjs";

const useStyles = makeStyles(() =>
    createStyles({
        horarioStyle: {
            color: "#FF0000",
            fontSize: "14px",
            textAlign: "center"
        }
    }),
);

interface IDialogDateProps {
    value?: Date;
    abierto: boolean;
    minDate: string;
    onClose: () => void;
    onSave: (date: Date | null, horaDe: string | null, horaHasta: string | null) => void;
    horarios?: string[];
    valueHoraDe?: Date;
    valueHoraHasta?: Date;
    hor?: any;
    esOrigen: boolean;
    aplicaReglasVentana: boolean;
    ventanaFija?: any,
    areaServicioRemitente: any,
    horariosAreaServicio?: any,
     esSolicitud?: boolean
}

interface StateProps {
    diasFestivos: IFechaFestiva[]
}

interface ParametroConfig {
    parametroId: number;
    valor: string;
}

type Props = StateProps & IDialogDateProps

const PickUpDateFueraHorario = ({ value, abierto, minDate, onClose, onSave, horarios, valueHoraDe, valueHoraHasta, hor, esOrigen, aplicaReglasVentana, ventanaFija, areaServicioRemitente, horariosAreaServicio, diasFestivos, esSolicitud  }: Props) => {
    const getDefaultDate = (): Date => {
        const base = value ? dayjs(value) : dayjs();
        // Si es sábado, avanzar al lunes siguiente
        if (base.day() === 6) return base.add(2, 'day').toDate();
        return base.toDate();
    };
    const defaultDate = getDefaultDate();
    const [selectedDate, setSelectedDate] = useState(defaultDate);
    const [selectedHoraDe, setSelectedHoraDe] = useState(valueHoraDe?.toTimeString().substring(0, 5));
    const [selectedHoraHasta, setSelectedHoraHasta] = useState(valueHoraHasta?.toTimeString().substring(0, 5));
    const { zonaHoraria, setZonaHoraria } = useZonaHoraria();
    const { enqueueSnackbar } = useSnackbar();
    const [arrayDiasFestivos, setArrayDiasFestivos] = useState(new Array);
    const [parametrosFinSemana, setParametrosFinSemana] = useState<ParametroConfig[]>([]);
    const apiSource = useCommonApi();
    React.useEffect(() => {
        if (abierto && areaServicioRemitente && areaServicioRemitente?.sucursal && (zonaHoraria.gmt === 0 || zonaHoraria.areaServicio !== areaServicioRemitente?.sucursal.id )) {
            getZonaHoraria().then(res => {
                if (res !== null && res.zona !== '') {
                    setZonaHoraria({ zona: res.zona, gmt: res.gmt, areaServicio: areaServicioRemitente?.sucursal?.id });
                }
            });


        }

    }, [value]);

    React.useEffect(() => {
       const parsearFecha = (d) => {
            let [dia, mes, anio] = d.fecha.split('/');
            return new Date(`${anio}-${mes}-${dia}T00:00:00`);
        };

                const fechasActuales = diasFestivos.map(parsearFecha);

        if(!esSolicitud && !esOrigen){
            setArrayDiasFestivos(fechasActuales);
        }
        else{
            getDiasInhabilProximos().then(res => {                 
                const fechasNuevas = res.map(parsearFecha);
                setArrayDiasFestivos([...fechasActuales, ...fechasNuevas]);
            });

            getParametroFinDeSemana().then(res => {
                const parametrosLimpios = res.map(param => ({
                    parametroId: param.parametroId,
                    valor: param.valor
                }));
                setParametrosFinSemana(parametrosLimpios);
            });
        }
    }, [diasFestivos]);

    const getZonaHoraria = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-zona-horaria/" + areaServicioRemitente?.sucursal?.id, {username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const getDiasInhabilProximos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/dias-inhabil-proximos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

     const getParametroFinDeSemana = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/parametro-fin-de-semana",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const handleDateChange = (date: Date) => {
        if (date == undefined) setSelectedDate(new Date());
        else
            setSelectedDate(date);
    };
    const handleHoraDeChange = (hora: Date) => {
        setSelectedHoraDe(hora?.toTimeString().substring(0, 5));
    };
    const handleHoraHastaChange = (hora: Date) => {
        setSelectedHoraHasta(hora?.toTimeString().substring(0, 5));
    };
    const classes = useStyles();

    const css = `
        .rs-picker-menu {
            z-index: 9999 !Important;
        }
        `

    const saveDate = () => {
        let selectedDateNumber = new Date(selectedDate).getDate();
        let actualDate = new Date();
        let diaSemana = new Date(selectedDate).getDay();
        let actualTimezone = actualDate.toLocaleTimeString('es', {timeZone: zonaHoraria.zona.toString()});
        let hourTimeZone = actualTimezone.split(":")[0];
        let minuteTimeZone = actualTimezone.split(":")[1];
        let horaUsuario = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), Number(hourTimeZone), Number(minuteTimeZone));
        
          if (!esSolicitud && (diaSemana === 0 || diaSemana === 6)) { 
            let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
            //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
            enqueueSnackbar(error, {variant: "error"});
            return;
        }

        if (!selectedDate) {
            enqueueSnackbar(traducirLabel(136), //"Fecha no válida.",
                { variant: "error" });
            return false;
        }

        if (!selectedHoraDe || !selectedHoraHasta) {
            enqueueSnackbar(traducirLabel(156), //"Hora no válida.", 
                { variant: "error" });
            return false;
        }

        if (new Date(selectedDate) < new Date() || new Date(selectedDate).getFullYear() < new Date().getFullYear()) {
            enqueueSnackbar(traducirLabel(136), //"Fecha no válida.", 
                { variant: "error" });
            return false;
        }

        if (ValidaFecha(selectedDate, selectedHoraDe, selectedHoraHasta) == false) {
            enqueueSnackbar(traducirMessage(146), //"La Fecha y/o Rango de horas se encuentra dentro del horario, favor de validar.", 
                { variant: "error" });
            return false;
        }
        let fechaCompara = new Date(selectedDate);
        let horaSeleccionadaInicio = new Date(fechaCompara.getFullYear(), Number(fechaCompara.getMonth()), fechaCompara.getDate(), new Date("2021-01-01 " + selectedHoraDe + ":00").getHours(), new Date("2021-01-01 " + selectedHoraDe + ":00").getMinutes());
        let horaSeleccionadaFin = new Date(fechaCompara.getFullYear(), Number(fechaCompara.getMonth()), fechaCompara.getDate(), new Date("2021-01-01 " + selectedHoraHasta + ":00").getHours(), new Date("2021-01-01 " + selectedHoraHasta + ":00").getMinutes());

        if (horaSeleccionadaInicio >= horaSeleccionadaFin) {
            enqueueSnackbar(traducirMessage(149), //"La hora final debe ser mayor a la hora de inicio, favor de validar.", 
                { variant: "error" });
            return false;
        }

        if (horariosAreaServicio.length) {
            let horaEntradaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horariosAreaServicio[0]['horaEntrada']).getHours(), new Date(horariosAreaServicio[0]['horaEntrada']).getMinutes());
            let horaSalidaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horariosAreaServicio[0]['horaSalida']).getHours(), new Date(horariosAreaServicio[0]['horaSalida']).getMinutes());

            //NO CUENTA VENTANA FIJA-SIN FRENCUENCIA SERVICIO
            if (!validaFrencuenciaArea(diaSemana)) {
                let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
                //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }

            //NO CUENTA VENTANA FIJA-EXCEDIO HORARIO DEL AREA DE SERVICIO
            if (selectedDateNumber === actualDate.getDate() && (horaUsuario > horaSalidaAreaServicio || horaUsuario < horaEntradaAreaServicio)) {
                let hi = new Date(horaEntradaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let hf = new Date(horaSalidaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let error = traducirMessage(44).replace('#####', areaServicioRemitente.nombre).replace('#####', hi).replace('#####', hf);
                //`El área de servicio ${areaServicioRemitente.nombre} solo permite la recolección entre las ${hi} - ${hf}. Favor de revisar con el administrador.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }
        }


        // if (aplicaReglasVentana===true)
        // {
        //     let message ="";
        //     if(localStorage.getItem("idioma") === 'en-US')
        //         message = traducirMessage(300) + ventanaFija.ventanaIng;
        //     else
        //         message = traducirMessage(300) + ventanaFija.ventanaEsp;
        //     let dateTovalidate = new Date(selectedDate);
        //     let day = dateTovalidate.getDay();
        //     if ((day === 1 && ventanaFija.lun === 0)
        //         || (day === 2 && ventanaFija.mar === 0)
        //         || (day === 3 && ventanaFija.mie === 0)
        //         || (day === 4 && ventanaFija.jue === 0)
        //         || (day === 5 && ventanaFija.vie === 0)
        //         || (day === 6 && ventanaFija.sab === 0)
        //         || (day === 0 && ventanaFija.dom === 0)
        //     ) {
        //
        //         enqueueSnackbar(message, // "Fecha no válida.",
        //             {variant: "error"});
        //         return false;
        //     }
        //
        //     let hourMinuteFrom = selectedHoraDe.split(":");
        //     let hourMinuteTo = selectedHoraHasta.split(":");
        //     let startDate = new Date(1900, 0, 1, ventanaFija.horaInicio.hours, ventanaFija.horaInicio.minutes, 0)
        //     let endDate = new Date(1900, 0, 1, ventanaFija.horaFin.hours, ventanaFija.horaFin.minutes, 0)
        //     let dateToValidate1 = new Date(1900,0,1,parseInt(hourMinuteFrom[0]) ,parseInt(hourMinuteFrom[1]),0);
        //     let dateTovalidate2 = new Date(1900,0,1,parseInt(hourMinuteTo[0]) ,parseInt(hourMinuteTo[1]) ,0);
        //
        //
        //     if(dateToValidate1 < startDate || dateToValidate1 > endDate
        //         || dateTovalidate2 < startDate || dateTovalidate2 > endDate
        //     )
        //     {
        //         enqueueSnackbar(message, // "Fecha no válida.",
        //             {variant: "error"});
        //         return false
        //     }
        //
        // }

        onSave(new Date(selectedDate), selectedHoraDe, selectedHoraHasta);
    };

    const validaFrencuenciaArea = (dia) => {
        let valido = false;
        if (horariosAreaServicio.length && horariosAreaServicio[0].dias) {
            valido = horariosAreaServicio[0].dias.filter(s => s.id === dia).length === 1;
            if(!valido && horariosAreaServicio.length>1)
            {
                valido = horariosAreaServicio[1].dias.filter(s => s.id === dia).length === 1;
            }
        }
        return valido;
    }
    const getDiasServiciosArea = (): string => {
        let dias: string[] = [];

        areaServicioRemitente.horarios?.forEach(h => {
            h.dias.forEach(d => {
                dias.push(d.nombre);
            })
        })

        return dias.join(", ");
    }

    const ValidaFecha = (fecha, horade, horaHasta) => {

        var diaValido = 0;
        var ret = true;

        let selectedDate = new Date(fecha);
        let dayOfWeek = new Date(fecha).getDay();
        //let actualDate = new Date();

        if (hor && hor.length) {

            // let horaEntradaAreaServicio = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date(hor[0]['horaEntrada']).getHours(), new Date(hor[0]['horaEntrada']).getMinutes());
            // let horaSalidaAreaServicio = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date(hor[0]['horaSalida']).getHours(), new Date(hor[0]['horaSalida']).getMinutes());

            let horaSeleccionadaInicio = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date("2021-01-01 " + horade + ":00").getHours(), new Date("2021-01-01 " + horade + ":00").getMinutes());
            let horaSeleccionadaFin = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date("2021-01-01 " + horaHasta + ":00").getHours(), new Date("2021-01-01 " + horaHasta + ":00").getMinutes());
            let index = 0;
            hor.forEach(t => {
                t.dias.forEach(s => {
                    if (s.id === dayOfWeek) {
                        diaValido = 1;
                    }
                });
                if (diaValido === 0)
                    index++;
            });

            if (diaValido === 0) {
                ret = true;
            }
            else {

                let horaEntradaAreaServicio = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date(hor[index]['horaEntrada']).getHours(), new Date(hor[index]['horaEntrada']).getMinutes());
                let horaSalidaAreaServicio = new Date(selectedDate.getFullYear(), Number(selectedDate.getMonth()), selectedDate.getDate(), new Date(hor[index]['horaSalida']).getHours(), new Date(hor[index]['horaSalida']).getMinutes());

                if ((horaSeleccionadaInicio > horaEntradaAreaServicio && horaSeleccionadaInicio < horaSalidaAreaServicio) ||
                    (horaSeleccionadaFin > horaEntradaAreaServicio && horaSeleccionadaFin < horaSalidaAreaServicio)) {
                    ret = false;
                }
                else {
                    ret = true;
                }

            }

        }
        return ret;
    }

    const getVentajaFija = (date) => {
        if(aplicaReglasVentana)
        {
            const day = date.getDay();

            if((day === 1 && ventanaFija.lun===1)
                || (day === 2 && ventanaFija.mar===1)
                || (day === 3 && ventanaFija.mie===1)
                || (day === 4 && ventanaFija.jue===1)
                || (day === 5 && ventanaFija.vie===1)
                || (day === 6 && ventanaFija.sab===1)
                || (day === 0 && ventanaFija.dom===1))
                return false
            else
                return true;
        }
        else
            return  false;

    };

    const getDiasFestivos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/obtener-dias-festivos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const esDiaFeriado = (date) => {
        date.setHours(0, 0, 0, 0);
        let esFestivo = false;
        const diaSemana = date.getDay();
        
         // Deshabilitar el sábado actual
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        if (diaSemana === 6 && date.getTime() === hoy.getTime() && hoy.getDay() === 6) {
            return true;
        }

          if (esSolicitud && !esOrigen) {
            const paramSabado = parametrosFinSemana.find(p => p.parametroId === 73);
            const paramDomingo = parametrosFinSemana.find(p => p.parametroId === 74);

            // Si es sábado y el valor NO es "1", entonces es festivo
            if (diaSemana === 6 && paramSabado?.valor !== "1") {
                return true;
            }

            // Si es domingo y el valor NO es "1", entonces es festivo
            if (diaSemana === 0 && paramDomingo?.valor !== "1") {
                return true;
            }
        }
        else if(!esSolicitud && (diaSemana === 0 || diaSemana === 6)) {
            return true;
        }

        arrayDiasFestivos.forEach(dia => {
        if (date.getTime() === dia.getTime()) {
            esFestivo = true;
        }
        });
        return esFestivo;
      };

    return (<>
        <Dialog open={abierto} maxWidth="sm" fullWidth={true} scroll={'body'}>
            <style>
                {css}
            </style>
            <DialogTitle id="simple-dialog-title">
                {/* Selecciona la fecha y hora de recolección Fuera de Horario */
                 esOrigen === false ? traducirMessage(305) : traducirMessage(240)}
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText className={classes.horarioStyle}>
                    <b>
                        <div>
                            {/* Horario Almex */
                                traducirLabel(158)}
                        </div>
                        {
                            horarios?.map((h, i) => (
                                <div key={i}>{h}</div>
                            ))
                        }</b>
                </DialogContentText>
                <DialogContentText>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>

                            <Box flexGrow={1}>
                                <b>
                                    {/* FECHA */
                                        traducirLabel(129)}
                                </b>
                                {localStorage.getItem("idioma") === 'en-US' &&
                                    <CustomProvider locale={en_US}>
                                        <DatePicker oneTap placement="autoHorizontalEnd"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        style={{ width: 200 }}
                                        onChange={handleDateChange}
                                        disabledDate={esDiaFeriado} 
                                    />
                                    </CustomProvider>
                                }
                                {localStorage.getItem("idioma") !== 'en-US' &&
                                    <CustomProvider locale={es_ES}>
                                        <DatePicker oneTap placement="autoHorizontalEnd"
                                        format="dd/MM/yyyy"
                                        value={selectedDate}
                                        style={{ width: 200 }}
                                        onChange={handleDateChange}
                                        disabledDate={esDiaFeriado} 
                                    />
                                    </CustomProvider>
                                }
                                
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box flexGrow={1}>
                                <b>
                                    {/* RANGO */
                                        traducirLabel(252)}
                                </b>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box flexGrow={1}>
                                {/* DESDE   */}
                                {traducirLabel(84)} <DatePicker placement="autoHorizontalEnd" onChange={handleHoraDeChange} format="HH:mm" ranges={[]} defaultValue={valueHoraDe} />
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box flexGrow={1}>
                                {/* HASTA  */}
                                {traducirLabel(154)} <DatePicker placement="autoHorizontalEnd" onChange={handleHoraHastaChange} format="HH:mm" ranges={[]}  defaultValue={valueHoraHasta} />
                            </Box>
                        </Grid>
                    </Grid>

                </DialogContentText>

            </DialogContent>
            <DialogActions>
                <Button onClick={saveDate} variant="contained" color="primary">
                    {/* Guardar */
                        traducirButton(12)}
                </Button>
                <Button onClick={onClose} variant="contained">
                    {/* Cerrar */
                        traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};
const mapStateToProps = (state: ApplicationState) => ({
    diasFestivos: state.diasFestivos
});
export default connect(mapStateToProps)(PickUpDateFueraHorario);
